<p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbHome"
              [styleClass]="(showIcons ? '' : 'hide-home-icon') + (breadcrumbItems.length === 0 ? ' empty-breadcrumbs' : '')">
    <ng-template pTemplate="item" let-item>
        <!-- Terminal item -->
        <ng-container *ngIf="item.routerLink">
            <a [routerLink]="item.routerLink" class="p-menuitem-link cursor-pointer">
                <zappIcon *ngIf="showIcons && item.icon" [themeIcon]="item.icon"></zappIcon>
                <span>{{ item.label }}</span>
            </a>
        </ng-container>
        <!-- Intermediate item -->
        <ng-container *ngIf="!item.routerLink">
            <div (click)="breadcrumbClicked(item, $event, op)" class="breadcrumb-intermediate-item">
                <zappIcon *ngIf="showIcons && item.icon" [themeIcon]="item.icon"></zappIcon>
                <span>{{ item.label }}</span>
            </div>
        </ng-container>
        <!-- Overlay -->
        <p-tieredMenu #op [model]="breadcrumbCurrentItems" [popup]="true" [styleClass]="'zapp-breadcrumbcontrol'"
                      appendTo="body">
            <ng-template pTemplate="item" let-item>
                <div class="p-menuitem-content">
                    <a pRipple [routerLink]="item.routerLink" [routerLinkActive]="['menu-item-active-route']"
                       class="p-ripple p-element p-menuitem-link p-menuitem-link-active">
                        <span class="p-menuitem-text">{{ item.label }}</span>
                        <div *ngIf="item.items" class="p-element p-icon-wrapper">
                            <i class="pi pi-angle-right"></i>
                        </div>
                    </a>
                </div>
            </ng-template>
        </p-tieredMenu>
    </ng-template>
</p-breadcrumb>
